// src/actions/blogActions.js
import {
  FETCH_BLOGS_REQUEST,
  FETCH_BLOGS_SUCCESS,
  FETCH_BLOGS_FAILURE,
  SAVE_BLOG_REQUEST,
  SAVE_BLOG_SUCCESS,
  SAVE_BLOG_FAILURE,
  DELETE_BLOG_REQUEST,
  DELETE_BLOG_SUCCESS,
  DELETE_BLOG_FAILURE,
} from "./types";

export const fetchBlogsRequest = (payload) => ({ type: FETCH_BLOGS_REQUEST, payload });
export const fetchBlogsSuccess = (data) => ({ type: FETCH_BLOGS_SUCCESS, payload: data });
export const fetchBlogsFailure = (error) => ({ type: FETCH_BLOGS_FAILURE, payload: error });

export const saveBlogRequest = (payload) => ({ type: SAVE_BLOG_REQUEST, payload });
export const saveBlogSuccess = (data) => ({ type: SAVE_BLOG_SUCCESS, payload: data });
export const saveBlogFailure = (error) => ({ type: SAVE_BLOG_FAILURE, payload: error });

export const deleteBlogRequest = (payload) => ({ type: DELETE_BLOG_REQUEST, payload });
export const deleteBlogSuccess = (data) => ({ type: DELETE_BLOG_SUCCESS, payload: data });
export const deleteBlogFailure = (error) => ({ type: DELETE_BLOG_FAILURE, payload: error });
